import { getBusinessConfig } from "@/apis/crypto";
import { DialogLocal } from "@/components/Dialog";
import { Toast } from "antd-mobile";
import { useEffect, useState } from "react";
import "./Description.scss";
import txt from "@/assets/images/merchant/subsidy/txt.png";
import merchant from "@/assets/images/merchant/subsidy/merchant.png";
import logo from "@/assets/images/merchant/subsidy/logo.png";
const data = {
  sellingConfig: {
    wechatAlipayAmountMin: {
      min: 10,
      max: 10000
    },
    wechatAlipayAmountMiddle: {
      min: 10001,
      max: 30000
    },
    wechatAlipayAmountMax: {
      min: 30001,
      max: 60000
    },
    bankCardAmountMin: {
      min: 33,
      max: 10000
    },
    bankCardAmountMiddle: {
      min: 10003,
      max: 30000
    },
    bankCardAmountMax: {
      min: 30001,
      max: 60000
    }
  },
  config: {
    silverBusinessDepositScope: {
      min: 1,
      max: 5000
    },
    silverBusinessWechatAlipayReward: {
      min: 1,
      middle: 1,
      max: 1
    },
    silverBusinessBankCardReward: {
      min: 1,
      middle: 1,
      max: 1
    },
    ordinaryBusinessDepositScope: {
      min: 1,
      max: 10000
    },
    ordinaryBusinessWechatAlipayReward: {
      min: 1,
      middle: 1,
      max: 1
    },
    ordinaryBusinessBankCardReward: {
      min: 1,
      middle: 1,
      max: 1
    },
    platinumGoldBusinessDepositScope: {
      min: 10001,
      max: 20000
    },
    platinumGoldBusinessWechatAlipayReward: {
      min: 2,
      middle: 2,
      max: 2
    },
    platinumGoldBusinessBankCardReward: {
      min: 2,
      middle: 2,
      max: 2
    },
    diamondBusinessDepositScope: {
      min: 20001,
      max: 30000
    },
    diamondBusinessWechatAlipayReward: {
      min: 3,
      middle: 3,
      max: 3
    },
    diamondBusinessBankCardReward: {
      min: 3,
      middle: 3,
      max: 3
    },
    crownBusinessDepositScope: {
      min: 30001,
      max: 40000
    },
    crownBusinessWechatAlipayReward: {
      min: 4,
      middle: 4,
      max: 4
    },
    crownBusinessBankCardReward: {
      min: 4,
      middle: 4,
      max: 4
    }
  }
};
export const Content = ({
  config,
  sellingConfig
}: any) => {
  return <div className="description_table description_dialog_table" data-sentry-component="Content" data-sentry-source-file="Description.tsx">
    <div className="earn_bg_box">
        <img className="earn_logo" src={logo} alt="" />
        <div className="earn_txt"> 
          <img src={txt} alt="" />
        </div>
        <div className="earn_txt2"> 
          <img src={merchant} alt="" />
        </div>
    </div>
    <table>
      <thead>
        {/* <tr>
          <th colSpan={6}>商家补贴比例（随市场和政策浮动）</th>
         </tr> */}
        <tr>
          {/* <th className="description_headLine">
            <span className="description_leftBottom">变现</span>
            <span className="description_rightTop">等级</span>
           </th> */}
          <th className="headLine">
              <span className="leftBottom">变现</span>
              <span className="rightTop">商家</span>
          </th>
          <th>
            白银
          </th>
          <th>
            黄金
          </th>
          <th>
            铂金
          </th>
          <th>
            钻石 
          </th>
          <th>
            皇冠 
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>保证金</td>
          <td>{config.silverBusinessDepositScope.min}U起</td>
          <td>{config.ordinaryBusinessDepositScope.min}U起</td>
          <td>{config.platinumGoldBusinessDepositScope.min}U起</td>
          <td>{config.diamondBusinessDepositScope.min}U起</td>
          <td>{config.crownBusinessDepositScope.min}U起</td>
        </tr>
        <tr>
          <td>
            微信/支付宝 <br />
            <span>小额{sellingConfig.wechatAlipayAmountMin.min}~{sellingConfig.wechatAlipayAmountMin.max}</span>
          </td>
          <td>{config.silverBusinessWechatAlipayReward.min}%</td>
          <td>{config.ordinaryBusinessWechatAlipayReward.min}%</td>
          <td>{config.platinumGoldBusinessWechatAlipayReward.min}%</td>
          <td>{config.diamondBusinessWechatAlipayReward.min}%</td>
          <td>{config.crownBusinessWechatAlipayReward.min}%</td>
        </tr>
        <tr>
          <td>
            微信/支付宝 <br />
            <span>中额{sellingConfig.wechatAlipayAmountMiddle.min}~{sellingConfig.wechatAlipayAmountMiddle.max}</span>
          </td>
          <td>{config.silverBusinessWechatAlipayReward.middle}%</td>
          <td>{config.ordinaryBusinessWechatAlipayReward.middle}%</td>
          <td>{config.platinumGoldBusinessWechatAlipayReward.middle}%</td>
          <td>{config.diamondBusinessWechatAlipayReward.middle}%</td>
          <td>{config.crownBusinessWechatAlipayReward.middle}%</td>
        </tr>
        <tr>
          <td>
            微信/支付宝 <br />
            <span>大额{sellingConfig.wechatAlipayAmountMax.min}以上</span>
          </td>
          <td>{config.silverBusinessWechatAlipayReward.max}%</td>
          <td>{config.ordinaryBusinessWechatAlipayReward.max}%</td>
          <td>{config.platinumGoldBusinessWechatAlipayReward.max}%</td>
          <td>{config.diamondBusinessWechatAlipayReward.max}%</td>
          <td>{config.crownBusinessWechatAlipayReward.max}%</td>
        </tr>
        <tr>
          <td>
            银行卡 <br />
            <span>小额{sellingConfig.bankCardAmountMin.min}~{sellingConfig.bankCardAmountMin.max}</span>
          </td>
          <td>{config.silverBusinessBankCardReward.min}%</td>
          <td>{config.ordinaryBusinessBankCardReward.min}%</td>
          <td>{config.platinumGoldBusinessBankCardReward.min}%</td>
          <td>{config.diamondBusinessBankCardReward.min}%</td>
          <td>{config.crownBusinessBankCardReward.min}%</td>
        </tr>
        <tr>
          <td>
            银行卡 <br />
            <span>中额{sellingConfig.bankCardAmountMiddle.min}~{sellingConfig.bankCardAmountMiddle.max}</span>
          </td>
          <td>{config.silverBusinessBankCardReward.middle}%</td>
          <td>{config.ordinaryBusinessBankCardReward.middle}%</td>
          <td>{config.platinumGoldBusinessBankCardReward.middle}%</td>
          <td>{config.diamondBusinessBankCardReward.middle}%</td>
          <td>{config.crownBusinessBankCardReward.middle}%</td>
        </tr>
        <tr>
          <td>
            银行卡 <br />
            <span>大额{sellingConfig.bankCardAmountMax.min}以上</span>
          </td>
          <td>{config.silverBusinessBankCardReward.max}%</td>
          <td>{config.ordinaryBusinessBankCardReward.max}%</td>
          <td>{config.platinumGoldBusinessBankCardReward.max}%</td>
          <td>{config.diamondBusinessBankCardReward.max}%</td>
          <td>{config.crownBusinessBankCardReward.max}%</td>
        </tr>
      </tbody>
    </table>
  </div>;
};
export const Description = () => {
  const [config, setConfig] = useState<any>(data.config);
  const [sellingConfig, setSellingConfig] = useState<any>(data.config);
  const fetchBusinessConfig = async () => {
    const {
      ok,
      data,
      msg
    } = await getBusinessConfig();
    if (ok) {
      setConfig(data.business_range_config);
      setSellingConfig(data.amount_range_config);
    } else {
      Toast.show(msg);
    }
  };
  useEffect(() => {
    fetchBusinessConfig();
  }, []);
  const showDetail = () => {
    DialogLocal({
      title: "",
      cancelText: "取消",
      content: <Content sellingConfig={sellingConfig} config={config} />
    });
  };
  return <div className="description_page" data-sentry-component="Description" data-sentry-source-file="Description.tsx">
    <div className="description_title">保证金规则说明：</div>
    <div className="description_content">
      <div className="description_title2">一、保证金规则</div>
      <div className="description_content2">
        <p>
          <span className="description_bold">1.高级商家说明：</span>
          主动缴纳保证金即可成为高级商家，高级商家可以享受更多特权、更多订单、更高补贴，系统根据缴纳保证金数额分为
          <span className="description_highlight">白银商家、黄金商家、 铂金商家、钻石商家、皇冠商家</span>。
        </p>
        <table className="description_table">
          <thead>
            <tr>
              <th>等级</th>
              <th>缴纳金额</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>白银商家</td>
              <td>
                {config.silverBusinessDepositScope.min}~
                {config.silverBusinessDepositScope.max}
                USDT
              </td>
            </tr>
            <tr>
              <td>黄金商家</td>
              <td>
                {config.ordinaryBusinessDepositScope.min}~
                {config.ordinaryBusinessDepositScope.max}
                USDT
              </td>
            </tr>
            <tr>
              <td>铂金商家</td>
              <td>
                {config.platinumGoldBusinessDepositScope.min}~
                {config.platinumGoldBusinessDepositScope.max}
                USDT
              </td>
            </tr>
            <tr>
              <td>钻石商家</td>
              <td>
                {config.diamondBusinessDepositScope.min}~{config.diamondBusinessDepositScope.max}
                USDT
              </td>
            </tr>
            <tr>
              <td>皇冠商家</td>
              <td>
                {config.crownBusinessDepositScope.min}
                USDT以上
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="description_title2">2.高级商家权益</div>
      <div className="description_content2">
        <p><span className="description_bold">（1）订单优先权：</span>高级商家享有订单优先权，可承接更多订单；</p>

        <p>
          <span className="description_bold"> （2）保证金利息：</span>缴纳保证金享有高额收益，利息每小时结算(时息=保证金本金×时利率）,利息超过1USDT可领取，领取利息按实时汇率兑换V币，自动存入VipPay钱包余额；
        </p>
        <p>
          <span className="description_bold"> （3）更高补贴：</span>
          高级商家比普通商家享有更高补贴，商家等级越高，补贴越高，详情请见
          <a onClick={showDetail}>商家补贴对照表</a>。
        </p>
      </div>
      <div className="description_title2">3.冻结保证金情形</div>
      <div className="description_content2">
        <p>
          <span className="description_bold">（1）优先冻结搬砖余额：</span>
          当变现或代付订单，被对方发起争议订单时，平台将按1:1比例，优先冻结商家余额，直到争议订单结束，此时不占用保证金额度；若判定商家败诉，将直接扣除相应商家余额；
        </p>
        <p>
          <span className="description_bold">（2）冻结保证金：</span>
          当代付、争议中变现订单累计金额大于商户余额，则按6:1的固定比例，冻结您的保证金，直到争议订单结束；若商家败诉，将直接扣除相应商家余额，不足不分则按实时汇率扣除相应保证金。
        </p>
      </div>
      <div className="description_title2">4.违规处罚</div>
      <div className="description_content2">
        <p>
          <span className="description_bold">（1）暂停变现或代付：</span>
          若您同时出现3笔或以上争议订单（包含变现或代付），系统会判定您的账号存在骗单或逃单可能，将暂停您的变现和代付功能，直到争议订单解决为止；
        </p>
        <p>
          <span className="description_bold">（2）一般违规：</span>
          若您被提起争议订单（例：<span className="description_highlight">恶意拖欠时间，提前操作已支付或未足额支付等违规</span>），经平台工作人员核查属实的，每违规1次暂停变现和代付功能24小时；若累计5次或以上的，将暂停变现和代付功能7天；若累计8次或以上的，将直接暂停变现和付功能30天，若累计10次或以上的，将直接取消商家资格；
        </p>
        <p>
          <span className="description_bold">（3）严重违规：</span>
          若您被提起争议订单（例：<span className="description_highlight">恶意终止交易，虚假操作已支付、骗单或逃单等情形</span>），经平台工作人员核查属实的，首次违规暂停变现、代付功能7天；若累计2次的，将直接取消商家资格；若累计3次或以上、金额巨大、不够赔付或其他严重情形的，将直接禁用账号，没收全部资产。
        </p>
      </div>
      <div className="description_title2">5.保证金转出</div>
      <div className="description_content2">
        保证金可以随时申请转出，申请转出24小时后自动到账；若转出过程中出现行的争议订单，且超额，将终止最近的转出申请，直到被冻结的商家余额+保证金≥争议订单总金额。
      </div>
    </div>
  </div>;
};